"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LINE_ENDINGS = void 0;
var LINE_ENDINGS = {
  POSIX: "\n",
  WIN32: "\r\n"
};
exports.LINE_ENDINGS = LINE_ENDINGS;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9jb25zdGFudHMvbGluZUVuZGluZ3MudHMiXSwibmFtZXMiOlsiTElORV9FTkRJTkdTIiwiUE9TSVgiLCJXSU4zMiJdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQU8sSUFBTUEsWUFBWSxHQUFHO0FBQzFCQyxFQUFBQSxLQUFLLEVBQUUsSUFEbUI7QUFFMUJDLEVBQUFBLEtBQUssRUFBRTtBQUZtQixDQUFyQiIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBjb25zdCBMSU5FX0VORElOR1MgPSB7XHJcbiAgUE9TSVg6IFwiXFxuXCIsXHJcbiAgV0lOMzI6IFwiXFxyXFxuXCIsXHJcbn07XHJcbiJdfQ==